import type { Router } from "vue-router";

export function changeQueryParam(
  router: Router,
  param: string,
  value: string
): ReturnType<typeof router.resolve> {
  const route = router.currentRoute.value;
  return router.resolve({
    ...route,
    query: {
      ...route.query,
      [param]: value
    }
  });
}
